import { UI_PRIMITIVE__slider } from '@/components/ui/slider/UI_PRIMITIVE__slider';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { assert_array_has_1_item, assert_equal } from '@shared/asserts/utils_asserts';
import { FIELD_PRIMITIVE__base_number } from '@shared/dto/generation/graph_invoke/_fields/_primitives/number/FIELD_PRIMITIVE__base_number';
import { useState } from 'react';

interface PROPS {
  field: FIELD_PRIMITIVE__base_number;
}

export function G_UI_FIELD_PRIMITIVE__number_slider({ field }: PROPS) {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   * STATE
   */
  let { graph } = generation_current.tool;
  const [value, set_value] = useState(field.get_value());

  /*
   * EFFECTS
   */
  use_effect(() => set_value(field.get_value()), [field.value]);

  /*
   * EVENTS
   */
  function onValueChange(values: number[]) {
    let value = assert_array_has_1_item(values);

    set_value(value);
  }

  async function onValueCommit(values: number[]) {
    let value = assert_array_has_1_item(values);

    if (value == field.get_value()) return;

    assert_equal(field.meta.graph_id, graph.meta.graph_id);

    let field_new = field.clone({ value });

    await UTILS__graph_data.update_field(graph, field_new);
  }

  /*
   * METHODS
   */
  function is_disabled() {
    return g_general__ui_disabled || field.meta.ui__is_readonly;
  }

  /*
   * HTML
   */
  return (
    <UI_PRIMITIVE__slider
      disabled={is_disabled()}
      min={field.get_values_allowed().min}
      max={field.get_values_allowed().max}
      step={field.slider_step}
      value={[value.to_fixed(2)]}
      defaultValue={[field.get_value().to_fixed(2)]}
      {...{ onValueChange, onValueCommit }}
      className="w-full"
    />
  );
}
